// appviews.js
// import { Platform } from "react-native";
import { faUser, faPaw, faCalendarCheck, faHeartPulse, faFileMedical, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
// import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";

// Public Views
import Login from "../Views/Auth/Login";
import Logout from "../Views/Auth/Logout";

// Main menu pages
// import Home from "components/Views/Home";
import Schedule from "components/Views/Schedule";
import Client from "components/Views/SideScreens/Client";
import Patient from "components/Views/SideScreens/Patient";
import Profile from "components/Views/Profile";

// // Inactive Account
// import Inactive from "../Views/Inactive";
// // Downtime / Scheduled Maintenance
// import Offline from "../Views/Offline";
// import Downtime from "../Views/Downtime";

//  /!\ Lower-case key names! /!\  \\
const appviews = {

  // Public pages
  // ⬇ LOGIN MUST BE FIRST BY DESIGN TO IT'S THE DEFAULT SCREEN
  login: {
    title: "Log In",
    view: Login,
    noheader: true,
    private: false,
    superadmin: false,
    menu: "",
  },

  // Main Menu Items
  // home: {
  //   title: "Home",
  //   view: Home,
  //   private: true,
  //   superadmin: false,
  //   menu: "main",
  //   icon: "home",
  // },

  profile: {
    title: "Profile",
    view: Profile,
    private: true,
    superadmin: false,
    // menu: "main",
    menu: "",
    icon: "user",
  },

  schedule: {
    title: "Schedule",
    view: Schedule,
    private: true,
    superadmin: false,
    menu: "main",
    icon: "calendar",
  },

  client: {
    key: "client",
    title: "Client Details",
    view: Client,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faUser,
  },

  patient: {
    key: "patient",
    title: "Patient Details",
    view: Patient,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faPaw,
  },

  checkin: {
    key: "checkin",
    title: "Appointment Check-In",
    view: Client,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faCalendarCheck,
  },

  visit: {
    key: "visit",
    title: "Visit Details",
    view: Client,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faHeartPulse,
  },

  assessment: {
    key: "assessment",
    title: "Open Assessment",
    view: Client,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faFileMedical,
  },

  billing: {
    key: "billing",
    title: "Billing",
    view: Client,
    private: true,
    superadmin: false,
    menu: "sidescreen",
    iconSource: "fa",
    icon: faFileInvoiceDollar,
  },

  logout: {
    title: "Log out",
    //view: Logout,
    //function: () => window.main.lib.setCurrentView("Logout"), // when function is needed
    function: Logout,  // view: Logout, // function not found error
    private: true,
    superadmin: false,
    menu: "main",
    icon: "log-out",
  },

  // inactive: {
  //   title: "Inactive Account",
  //   view: Inactive,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // downtime: {
  //   title: "Scheduled Maintenance",
  //   view: Downtime,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },
  // offline: {
  //   title: "Offline",
  //   view: Offline,
  //   noheader: true,
  //   external: true,
  //   private: false,
  //   superadmin: false,
  //   menu: "",
  // },

};

appviews.keys = Object.keys(appviews);
appviews.publicKeys = Object.keys(appviews).filter(key=>(!appviews[key].private));
appviews.mainMenuKeys = Object.keys(appviews).filter(key=>(appviews[key].menu==="main"));
// appviews.externalKeys = Object.keys(appviews).filter(key => !!appviews[key].external && !!appviews[key].menu!=="admin");

export default appviews;
